import { parseEmbedTokens } from '@/components/artifact-editor/parseEmbedTokens'

export function hasStudyDocEmbeds(markdown: string): boolean {
  return parseEmbedTokens(markdown).some((segment) => segment.kind !== 'text')
}
